import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../../customs/endpoints";
import {CommonResponse} from "../../customs/_models/Response";
import {map, Observable, of} from "rxjs";
import {ExploitationType, ExpoilataionDto} from "../../customs/_models/exploitation.dtos";
import {HandleErrorsService} from "../handle-erros/handle.errors.service";
import {catchError} from "rxjs/operators";
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ExploitationService {

    constructor(private http: HttpClient,
                private endPoints: Endpoints,
                private handleErrorsService: HandleErrorsService) {
    }
  private apiUrl1 = `${environment.base_url}/api/exploitation-types`;


  getAllTypes(): Observable<ExploitationType[]> {
    return this.http.get<ExploitationType[]>(this.apiUrl1);
  }
    fetchExploitationList(): Observable<ExpoilataionDto[]> {
        return this.http.get<CommonResponse>(this.endPoints.client_exploitation_base_endpoint).pipe(
            map(response => response.status ? response.data : []),
            catchError(err => {
                this.handleErrorsService.catchError(err);
                return of([]); // Return an empty array in case of error
            })
        );
    }
        fetchExploitationsByClient(clientId: number): Observable<ExpoilataionDto[]> {
        const url = `${this.endPoints.client_exploitation_base_endpoint}/${clientId}`;
        return this.http.get<CommonResponse>(url).pipe(
            map(response => {
            if (response.status) {
                return response.data; // c'est la liste des exploitations
            } else {
                return [];
            }
            })
        );
        }


    save(exploitation: ExpoilataionDto): Observable<CommonResponse> {
        return this.http.post<CommonResponse>(this.endPoints.client_exploitation_base_endpoint, exploitation)

    }

    update(exploitation: ExpoilataionDto): Observable<CommonResponse> {
        return this.http.put<CommonResponse>(this.endPoints.client_exploitation_base_endpoint, exploitation)
    }

    delete(id: number) {
        return this.http.delete<CommonResponse>(`${this.endPoints.client_exploitation_base_endpoint}/${id}`)
    }
}
